import { useState } from 'react';
import Box from '@mui/material/Box';
import { useTranslate, MenuProps } from 'react-admin';
import { Button, Menu } from '@mui/material';
import { AppBarMenuItemLink } from './AppBarMenuItemLink';
import { useLocation } from 'react-router';
import { AppBarMenuItemAccessLink } from './AppBarMenuItemAccessLink';
import { MembershipType } from '../../payWall/paywall.model';


export const AppBarMenu = ({ }: MenuProps) => {
  const translate = useTranslate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const location = useLocation();

  const mapMenuItems: Array<{ to: string; primaryText: string; membership: MembershipType }> = [
    { to: '/data/zip', primaryText: 'Zip', membership: 'Free' },
    { to: '/data/neighborhood', primaryText: 'Neighborhoods', membership: 'Novice' },
    { to: '/data/schools', primaryText: 'Schools', membership: 'Pro' },
  ];
  // Check if current route is one of the map menu items
  const isMapRoute = mapMenuItems.some(item => location.pathname.startsWith(item.to));

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <Button
        aria-controls={open ? 'app-bar-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform: 'none',
          color: isMapRoute ? 'inherit' : 'secondary.main',
        }}
      >
        Map
      </Button>
      <Menu
        id='app-bar-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {mapMenuItems.map(item => (
          <AppBarMenuItemAccessLink
            key={item.to}
            to={item.to}
            membership={item.membership}
            onClick={handleClose}
            primaryText={item.primaryText}
          />
        ))}
      </Menu>
      <AppBarMenuItemLink
        to="/pricing"
        primaryText="Plans & Pricing"
      />
      <AppBarMenuItemLink
        to="/howto"
        primaryText="How To's"
      />
      <AppBarMenuItemLink
        to="/audience"
        primaryText="Audience"
      />
      <AppBarMenuItemLink
        to="/about"
        primaryText="About"
      />
    </Box>
  );
};
